export default __webpack_public_path__ + "static/media/user-tick.448519fb.svg";